import {Component, HostListener} from '@angular/core';

interface ScreenshotItem {
  src: string;
  alt: string;
  title: string;
  description: string;
}

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.css'],
    standalone: false
})
export class LandingComponent {
  screenshots: ScreenshotItem[] = [
    {
      src: 'assets/Plantagen Übersicht.png',
      alt: 'Screenshot der Plantagen Übersicht',
      title: 'Plantage im Überblick',
      description: 'Zeigt alle Felder mit Beschreibung, Reihenanzahl und Gesamt-Ertrag pro Saison.'
    },
    {
      src: 'assets/Feld Baum Ansicht mit Ertrag.png',
      alt: 'Screenshot der Feld/Baum Ansicht mit Erträgen',
      title: 'Feld & Baum Detail',
      description: 'Detailansicht pro Baum inklusive Sponsor, Erträgen pro Jahr und Bonusinformationen.'
    },
    {
      src: 'assets/Baum detail Ansicht.png',
      alt: 'Screenshot der Baum Detail Ansicht',
      title: 'Baum Detail Ansicht',
      description: 'Zeigt Navigation zwischen Bäumen, Tooltips mit Jahreserträgen und Aktionen wie Trüffel erfassen.'
    },
    {
      src: 'assets/Paten Übersicht.png',
      alt: 'Screenshot der Paten Übersicht',
      title: 'Paten & Sponsoren',
      description: 'Schnellzugriff auf Kontaktinfos, Paten seit-Datum und direkter Sprung zu ihren Bäumen.'
    }
  ];

  featureHighlights = [
    {
      title: 'Plantagen im Blick',
      description: 'Alle Felder, Reihen und Bäume live inklusive Jahreserträgen und Produktivitätsstatus.',
      badge: 'Live Monitoring'
    },
    {
      title: 'Patenverwaltung',
      description: 'Suche, sortiere und bearbeite Sponsoren, setze Berechtigungen und verschicke Updates.',
      badge: 'CRM'
    },
    {
      title: 'Dokumentierte Ernten',
      description: 'Trüffelfunde mit Datum, Gewicht und Qualität – inklusive Historie zum Vergleich.',
      badge: 'Historie'
    },
    {
      title: 'Mobile ready',
      description: 'Als PWA installierbar – Benachrichtigungen und Offline-Unterstützung inklusive.',
      badge: 'PWA'
    }
  ];

  workflowSteps = [
    {
      title: 'Felder und Reihen anlegen',
      text: 'Definiere deine Plantagenstruktur inklusive Beschreibungen, Bildern und Metadaten.'
    },
    {
      title: 'Bäume verknüpfen',
      text: 'Ordne Paten zu, erfasse Sponsoring seit-Datum und halte Kontaktinformationen aktuell.'
    },
    {
      title: 'Trüffel dokumentieren',
      text: 'Jede Ernte wird pro Baum mit Gewicht, Qualität und Notizen gespeichert.'
    },
    {
      title: 'Insights teilen',
      text: 'Analysiere Jahreserträge per Tooltip, filtere nach Jahren und exportiere Reports.'
    }
  ];

  selectedScreenshot: ScreenshotItem | null = null;

  openScreenshot(screenshot: ScreenshotItem): void {
    this.selectedScreenshot = screenshot;
  }

  closeScreenshot(): void {
    this.selectedScreenshot = null;
  }

  @HostListener('document:keydown.escape')
  handleEscape(): void {
    if (this.selectedScreenshot) {
      this.closeScreenshot();
    }
  }
}
